import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { showSpinner, TypedRoute } from '@shared/utils';
import { AuthService } from '@core/auth';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss',
})
export class OnboardingComponent {
  destroyRef = inject(DestroyRef);
  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<{ token: string }>,
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {
    this.route.data.subscribe((data) => {
      if (data.token) {
        if (data.token === 'finish') {
          // If user is not authenticated, onboarding/finish assumes that finish is a token.
          // We need to inform user that he is not authenticated and forward to login (using logout flow)
          this.toastService.add({
            message: this.translateService.instant('Common.Errors.TokenInvalid'),
            type: 'error',
          });
          this.authService.logOut();
        } else {
          this.authService
            .logOutWithoutRedirect()
            .pipe(switchMap(() => this.authService.verifySignupJWT(data.token)))
            .pipe(showSpinner())
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (data) => {
                if (!data.meta?.session_token) {
                  this.showUnknownErrorToast();
                  this.redirectToLogin();
                } else {
                  this.authService.logIn(data.meta.session_token, '/onboarding/finish');
                }
              },
              error: (error: HttpErrorResponse) => {
                this.authService.showTokenVerifyErrorToast(error);
                this.redirectToLogin();
              },
            });
        }
      }
    });
  }
  showUnknownErrorToast() {
    this.toastService.add({
      message: this.translateService.instant('Common.Errors.UnknownError'),
      type: 'error',
    });
  }

  private redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
